import { accountIdFormat } from "@redotech/redo-account-id";
import { MerchantConsolidationBinCriteriaSchema } from "@redotech/redo-return-warehouse-processing-common/merchant-consolidation-bin";
import {
  merchantConsolidationBinIdFormat,
  returnsCenterIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const createConsolidationBins = {
  name: "createConsolidationBins" as const,
  input: z.object({
    binCount: z.number().int().min(1),
    criteria: MerchantConsolidationBinCriteriaSchema,
    merchantAccountId: accountIdFormat.schema,
    namePrefix: z.string().trim().min(1),
    returnsCenterId: returnsCenterIdFormat.schema,
  }),
  output: z.object({ ids: z.array(merchantConsolidationBinIdFormat.schema) }),
};
